import React from 'react';
type CaseSectionProps = {
  index: string;
  label: string;
  title: string;
  intro?: React.ReactNode;
  children?: React.ReactNode;
};
export function CaseSection({
  index,
  label,
  title,
  intro,
  children
}: CaseSectionProps) {
  return <section className="mt-20 md:mt-28" data-id="element-43" data-mp="6v94t028xctv">
      <div className={intro ? 'grid gap-5 md:grid-cols-2 md:gap-12' : ''} data-id="element-44" data-mp="1y98vhz41qgh">
        <div data-id="element-45" data-mp="20dblwl9wjf6">
          <p className="text-xs font-medium text-rust" data-id="element-46" data-mp="3u1tdio22zpek">
            <span className="tabular-nums" data-id="element-47" data-mp="3u3cs8a839se8">{index}</span> / {label}
          </p>
          <h2 className="mt-2 max-w-xl text-2xl font-semibold leading-snug tracking-tight text-ink md:text-[27px]" data-id="element-48" data-mp="3pa1ucyl98lyg">
            {title}
          </h2>
        </div>
        {intro && <div className="space-y-4 text-[15px] leading-relaxed text-fg-muted md:pt-6" data-id="element-49" data-mp="3fdfdekw1uf1p">{intro}</div>}
      </div>
      {children && <div className="mt-8 md:mt-10" data-id="element-50" data-mp="3acrcn7i0qjua">{children}</div>}
    </section>;
}